import { css } from '@emotion/core';
import { aTag, tokens, media } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var mini = designTokenFonts.mini,
  miniBold = designTokenFonts.miniBold,
  subheading = designTokenFonts.subheading,
  displaySmall = designTokenFonts.displaySmall;
var colours = tokens.colors,
  spacing = tokens.spacing;
export var agencyDetails = /*#__PURE__*/css("width:100%;padding:16px 0;", media('>=tablet'), "{padding:16px;width:45%;margin-right:22px;}", media('>=desktop'), "{width:475px;padding:30px;}");
export var heading = /*#__PURE__*/css(displaySmall, ";margin-bottom:8px;", media('>=tablet'), "{margin-bottom:10px;}", media('>=desktop'), "{margin-bottom:16px;}");
var _ref = {
  name: "17xq7l1",
  styles: "margin:16px 0 16px;"
};
var _ref2 = {
  name: "ug8j3x",
  styles: "margin:16px 0 24px;"
};
export var agencyHeader = _ref3 => {
  var _ref3$hasRei = _ref3.hasRei,
    hasRei = _ref3$hasRei === void 0 ? false : _ref3$hasRei;
  return /*#__PURE__*/css("display:flex;align-items:center;gap:16px;margin:12px 0 16px;", media('>=tablet'), "{", hasRei ? _ref : _ref2, "}");
};
export var logoLink = {
  name: "1tu59u4",
  styles: "flex:0 0 auto;"
};
export var logo = {
  name: "11ep52w",
  styles: "display:block;object-fit:contain;width:96px;height:42px;"
};
export var agency = /*#__PURE__*/css(subheading, ";");
export var agencyLink = /*#__PURE__*/css(mini, " text-decoration:none;color:", colours.neutral.medium.default, ";&:hover{color:", colours.neutral.medium.hover, ";}");
export var link = /*#__PURE__*/css(miniBold, ";", aTag, ";display:inline-block;margin-bottom:20px;color:", colours.neutral.heavy.default, ";&:hover{color:", colours.neutral.heavy.hover, ";}");
export var rei = /*#__PURE__*/css("display:flex;align-items:center;margin-bottom:", spacing.s, ";");
export var reiText = /*#__PURE__*/css(mini, ";display:inline-block;color:", colours.neutral.medium.default, ";margin-right:", spacing.xs, ";");
export var linkItemArrow = /*#__PURE__*/css("vertical-align:middle;color:", colours.neutral.heavy.default, ";");
export var separatorWithMargin = /*#__PURE__*/css("margin-bottom:", spacing.s, ";");